import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { Field, HiddenField } from 'embed/constants'

const NO_MARGIN = 'initial'

const formatMargin = (value?: number): string => (typeof value !== 'undefined' ? `${value}px` : NO_MARGIN)

const styles = require('embed/styles/application')
const CheckGreen = require('../check-green.svg')

export interface Props {
  colorError?: string
  colorTextSecondary: string
  field: Field
  fontFamilyPrimary: string
  isValid: boolean
  shouldShowIsValid: boolean
  shouldShowIsInvalid: boolean
  styles?: string
  marginRight?: number
}

export const Status: React.FC<Props> = (props: Props) => {
  let status

  if (props.field.options.required) {
    if (props.shouldShowIsValid && props.field instanceof HiddenField === false) {
      status = (
        <span className={styles.isValid}>
          <CheckGreen />
        </span>
      )
    } else if (props.shouldShowIsInvalid && props.field instanceof HiddenField === false) {
      status = (
        <span
          className={classnames(
            styles.invalid,
            css`
              color: ${props.colorError};
              font-family: ${props.fontFamilyPrimary};
              margin-right: ${formatMargin(props.marginRight)};
            `,
          )}
        >
          Invalid
        </span>
      )
    } else if (props.field instanceof HiddenField === false && props.isValid === false) {
      status = (
        <span
          className={classnames(
            styles.required,
            css`
              color: ${props.colorTextSecondary};
              font-family: ${props.fontFamilyPrimary};
              margin-right: ${formatMargin(props.marginRight)};
            `,
          )}
        >
          Required
        </span>
      )
    }
  } else if (props.field instanceof HiddenField === false) {
    status = (
      <span
        className={classnames(
          styles.required,
          css`
            color: ${props.colorTextSecondary};
            font-family: ${props.fontFamilyPrimary};
            margin-right: ${formatMargin(props.marginRight)};
          `,
        )}
      >
        Optional
      </span>
    )
  }

  return status === undefined ? null : <React.Fragment>{status}</React.Fragment>
}
